import React, { memo } from 'react';

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { observer } from 'mobx-react';

import { useStore } from 'mobx/helpers';

import CrmSnackbar from 'components/Snackbar';

import { CheckCircle } from './CheckCircle';

const CrmSnackbarFeedback = observer(() => {
  const store = useStore();

  return (
    <CrmSnackbar
      anchorOrigin={{ vertical: 'top', horizontal: store.isSnackbarSuccess ? 'right' : 'center' }}
      open={store.snackbarOpen}
      onClose={() => store.setSnackbar(false)}
    >
      {!store.isSnackbarSuccess ? (
        <div className='snackbar-body'>
          <CheckIcon style={{ marginRight: '5px' }} />
          {store.snackbarMessage}
        </div>
      ) : (
        <div className='snackbar-body snackbar-body-success'>
          <div className='container-icon'>
            <CheckCircle />
            {store.snackbarMessage}
          </div>
          <CloseIcon className='iconClose' onClick={() => store.setSnackbar(false)} />
        </div>
      )}
    </CrmSnackbar>
  );
});

export default memo(CrmSnackbarFeedback);
